
export default {
  name: "ButtonHome",
  props: {
    propsClass: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: '返回首页'
    }
  },
  methods: {
    linkHome() {
      this.$emit('linkHome')
    }
  }
}
